/* eslint-disable import/no-mutable-exports */
import clientConfig from '@/client_customs/config';
import useUsersAccessRightStore from '@/stores/users/accessRight';

function getDefaultColors() {
  const defaultColors = [
    {
      label: '',
      sublabels: ['', '', '', '', ''],
    },
    {
      label: '',
      sublabels: ['', '', '', '', ''],
    },
    {
      label: '',
      sublabels: ['', '', '', '', ''],
    },
    {
      label: '',
      sublabels: ['', '', '', '', ''],
    },
    {
      label: '',
      sublabels: ['', '', '', '', ''],
    },
    {
      label: '',
      sublabels: ['', '', '', '', ''],
    },
    {
      label: '',
      sublabels: ['', '', '', '', ''],
    },
    {
      label: '',
      sublabels: ['', '', '', '', ''],
    },
  ];

  let colorsConfig = useUsersAccessRightStore().config.colors;
  if (! colorsConfig && clientConfig.colors) {
    console.error('colors config not found in accessRight config');
    colorsConfig = clientConfig.icons;
  }
  if (colorsConfig) {
    if (clientConfig.colorsOptions?.customLayout) {
      defaultColors.splice(0, defaultColors.length, ...colorsConfig);
      return defaultColors;
    }

    defaultColors.forEach((color, index) => {
      if (! colorsConfig[index]) return;
      if (typeof colorsConfig[index].label == 'string') color.label = colorsConfig[index].label;
      if (colorsConfig[index].sublabels && colorsConfig[index].sublabels.length == 5) color.sublabels = colorsConfig[index].sublabels;
    });
  }

  return defaultColors;
}

function getDefaultIcons() {
  let defaultIcons = {
    milestone0: { name: 'fak fa-bbp-milestone', color: 'primary', label: '' },
    milestone1: { name: 'fak fa-bbp-milestone', color: 'warningorange', label: '' },
    milestone2: { name: 'fak fa-bbp-milestone', color: 'successgreen', label: '' },
    milestone3: { name: 'fak fa-bbp-milestone', color: 'errorred', label: '' },
    milestone4: { name: 'fak fa-bbp-milestone', color: 'info', label: '' },
    milestone5: { name: 'fak fa-bbp-milestone', color: 'darkgrey', label: '' },
    danger: { name: 'fas fa-times-circle', color: 'errorred', label: '' },
    warning: { name: 'fas fa-exclamation-triangle', color: 'warningorange', label: '' },
    done: { name: 'fas fa-check-circle', color: 'successgreen', label: '' },
    question: { name: 'fas fa-question-circle', color: 'primary', label: '' },
    information: { name: 'fas fa-info-circle', color: 'primary', label: '' },
    forbidden: { name: 'fas fa-minus-circle', color: 'errorred', label: '' },
    phone: { name: 'fas fa-phone', color: 'primary', label: '' },
    email: { name: 'fas fa-envelope', color: 'successgreen', label: '' },
    document: { name: 'far fa-file-alt', color: 'darkgrey', label: '' },
    signature: { name: 'far fa-edit', color: 'successgreen', label: '' },
    send: { name: 'fas fa-paper-plane', color: 'info', label: '' },
    talk: { name: 'fas fa-bullhorn', color: 'primary', label: '' },
    user: { name: 'fas fa-user', color: 'primary', label: '' },
    users: { name: 'fas fa-users', color: 'successgreen', label: '' },
    userFriends: { name: 'fas fa-user-friends', color: 'info', label: '' },
    rocket: { name: 'fas fa-rocket', color: 'successgreen', label: '' },
    fire: { name: 'fas fa-burn', color: 'errorred', label: '' },
    target: { name: 'fas fa-bullseye-arrow', color: 'successgreen', label: '' },
    sun: { name: 'fas fa-sun', color: 'warningorange', label: '' },
    sunCloud: { name: 'fas fa-cloud-sun', color: 'info', label: '' },
    rain: { name: 'fas fa-cloud-rain', color: 'primary', label: '' },
    storm: { name: 'fas fa-poo-storm', color: 'errorred', label: '' },
    pin: { name: 'fas fa-thumbtack', color: 'primary', label: '' },
    pin3: { name: 'fas fa-thumbtack', color: 'errorred', label: '' },
    instagram: { name: 'fab fa-instagram', color: '#833AB4', label: '' },
    linkedin: { name: 'fab fa-linkedin', color: '#0077B5', label: '' },
    youtube: { name: 'fab fa-youtube', color: '#FF0000', label: '' },
    facebook: { name: 'fab fa-facebook', color: '#1877F2', label: '' },
    twitter: { name: 'fab fa-x-twitter', color: '#000000', label: '' },
    whatsapp: { name: 'fab fa-whatsapp', color: '#25D366', label: '' },
    euro: { name: 'fas fa-euro-sign', color: 'warningorange', label: '' },
    lock: { name: 'fas fa-lock', color: 'errorred', label: '' },
    unlock: { name: 'fas fa-unlock-alt', color: 'successgreen', label: '' },
    desktop: { name: 'fas fa-desktop', color: 'primary', label: '' },
    laptop: { name: 'fas fa-laptop', color: 'successgreen', label: '' },
    mobile: { name: 'fas fa-mobile-alt', color: 'warningorange', label: '' },
    alarm: { name: 'fas fa-alarm-clock', color: 'errorred', label: '' },
    time: { name: 'fas fa-hourglass-half', color: 'warningorange', label: '' },
    clock: { name: 'fas fa-clock', color: 'info', label: '' },
    handshake: { name: 'fas fa-handshake', color: 'successgreen', label: '' },
    help: { name: 'fas fa-hands-helping', color: 'warningorange', label: '' },
    halt: { name: 'fas fa-hand-paper', color: 'errorred', label: '' },
    star: { name: 'fas fa-star', color: 'primary', label: '' },
    star1: { name: 'fas fa-star', color: 'warningorange', label: '' },
    star2: { name: 'fas fa-star', color: 'successgreen', label: '' },
    star3: { name: 'fas fa-star', color: 'errorred', label: '' },
    star4: { name: 'fas fa-star', color: 'info', label: '' },
    star5: { name: 'fas fa-star', color: 'darkgrey', label: '' },
    happy: { name: 'far fa-smile', color: 'successgreen', label: '' },
    sad: { name: 'far fa-frown', color: 'errorred', label: '' },
    toolbox: { name: 'fas fa-toolbox', color: 'primary', label: '' },
    admin: { name: 'fas fa-user-shield', color: 'warningorange', label: '' },
    secret: { name: 'fas fa-user-secret', color: 'errorred', label: '' },
    manager: { name: 'fas fa-user-tie', color: 'primary', label: '' },
    appreciation: { name: 'fas fa-thumbs-up', color: 'successgreen', label: '' },
    bad: { name: 'fas fa-thumbs-down', color: 'errorred', label: '' },
    go: { name: 'fas fa-traffic-light-go', color: 'successgreen', label: '' },
    slow: { name: 'fas fa-traffic-light-slow', color: 'warningorange', label: '' },
    stop: { name: 'fas fa-traffic-light-stop', color: 'errorred', label: '' },
    trophy: { name: 'fas fa-trophy', color: 'warningorange', label: '' },
    tasks: { name: 'fas fa-tasks', color: 'primary', label: '' },
    comment: { name: 'fas fa-comment', color: 'successgreen', label: '' },
    cog: { name: 'fas fa-cog', color: 'darkgrey', label: '' },
    stats: { name: 'fas fa-chart-pie', color: 'primary', label: '' },
    chartline: { name: 'fas fa-chart-line', color: 'successgreen', label: '' },
    chartbar: { name: 'fas fa-chart-bar', color: 'warningorange', label: '' },
    image: { name: 'far fa-image', color: 'primary', label: '' },
    video: { name: 'fab fa-youtube', color: 'info', label: '' },
    industry: { name: 'fas fa-industry', color: 'warningorange', label: '' },
    company: { name: 'fas fa-building', color: 'info', label: '' },
    store: { name: 'fas fa-store', color: 'primary', label: '' },
    warehouse: { name: 'fas fa-warehouse', color: 'darkgrey', label: '' },
    calendar: { name: 'fas fa-calendar-alt', color: 'info', label: '' },
    newDate: { name: 'fas fa-calendar-plus', color: 'successgreen', label: '' },
    book: { name: 'fas fa-book', color: 'darkgrey', label: '' },
    gift: { name: 'fas fa-gift', color: 'successgreen', label: '' },
    tools: { name: 'fas fa-tools', color: 'info', label: '' },
    design: { name: 'fas fa-pencil-ruler', color: 'successgreen', label: '' },
    digging: { name: 'fas fa-digging', color: 'warningorange', label: '' },
    binoculars: { name: 'fas fa-binoculars', color: 'primary', label: '' },
    quality: { name: 'fas fa-gem', color: 'info', label: '' },
    buld: { name: 'fas fa-lightbulb', color: 'warningorange', label: '' },
    lightbuld: { name: 'fas fa-lightbulb-on', color: 'successgreen', label: '' },
    press: { name: 'fas fa-newspaper', color: 'darkgrey', label: '' },
    presentation: { name: 'fas fa-presentation', color: 'successgreen', label: '' },
    conference: { name: 'fas fa-users-class', color: 'info', label: '' },
    powerpoint: { name: 'fas fa-file-powerpoint', color: 'info', label: '' },
    certificate: { name: 'fas fa-file-certificate', color: 'successgreen', label: '' },
    bill: { name: 'fas fa-money-bill', color: 'primary', label: '' },
    attachement: { name: 'fas fa-paperclip', color: 'successgreen', label: '' },
    globe: { name: 'fas fa-globe', color: 'primary', label: '' },
    sitemap: { name: 'fas fa-sitemap', color: 'info', label: '' },
    redo: { name: 'fas fa-redo', color: 'primary', label: '' },
    sync: { name: 'fas fa-sync', color: 'info', label: '' },
    flag: { name: 'fas fa-flag', color: 'successgreen', label: '' },
    endflag: { name: 'fas fa-flag-checkered', color: 'warningorange', label: '' },
    route: { name: 'fas fa-route', color: 'successgreen', label: '' },
    truck: { name: 'fas fa-truck', color: 'warningorange', label: '' },
    car: { name: 'fas fa-car', color: 'primary', label: '' },
    plane: { name: 'fas fa-plane', color: 'info', label: '' },
    ship: { name: 'fas fa-ship', color: 'primary', label: '' },
    bulldozer: { name: 'fas fa-truck-plow', color: 'errorred', label: '' },
    position: { name: 'fas fa-map-marker-alt', color: 'primary', label: '' },
    location: { name: 'fas fa-location', color: 'info', label: '' },
    database: { name: 'fas fa-database', color: 'primary', label: '' },
    windturbine: { name: 'fas fa-wind-turbine', color: 'primary', label: '' },
    shareAlt: { name: 'fas fa-share-alt', color: 'primary', label: '' },
    share: { name: 'fas fa-share', color: 'successgreen', label: '' },
  };

  let iconsConfig = useUsersAccessRightStore().config.icons;
  if (! iconsConfig && clientConfig.icons) {
    console.error('icons config not found in accessRight config');
    iconsConfig = clientConfig.icons;
  }
  if (iconsConfig) {
    if (iconsConfig.replace) {
      defaultIcons = iconsConfig.replace;
    } else {
      (iconsConfig.remove || []).forEach((item) => { delete defaultIcons[item]; });
      const position = iconsConfig.position || 0;
      const iconsKeys = Object.keys(defaultIcons);
      let customIcons = {};
      iconsKeys.slice(0, position).forEach((item) => { customIcons[item] = defaultIcons[item]; });
      customIcons = { ...customIcons, ...iconsConfig.add };
      iconsKeys.slice(position).forEach((item) => {
        customIcons[item] = _.extend(defaultIcons[item], customIcons[item]);
      });
      defaultIcons = customIcons;
    }
  }

  return defaultIcons;
}

function getDefaultRemovedIcons() { // for display on planning elements
  return {
    neutral: { name: 'far fa-meh', color: 'darkgrey', label: '' },
  };
}

export { getDefaultColors, getDefaultIcons, getDefaultRemovedIcons };
